export type UiSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"

export const uiSizeToBaseSize = (size: UiSize): number => {
  switch (size) {
    case "xxs":
      return 8
    case "xs":
      return 12
    case "sm":
      return 16
    case "md":
      return 32
    case "lg":
      return 64
    case "xl":
      return 80
    default:
      return 120
  }
}
